import { Stack, Typography } from "@mui/material"
import React from "react"
import Question from "./Question"
import QuestionMulti from "./QuestionMulti"

const Questionaire = ({questionaire, getDataFromPointer, updateData, triggerAction, contextArea, variant = "DEFAULT"}) => {
    const questions = questionaire.connections?.map(entry => entry.origin)
    return <Stack spacing={variant === "BORDERLESS" ? 3 : 2}>
            {variant === "DEFAULT" && questionaire?.longname && <Typography variant="h2" component="h2">{questionaire?.longname}</Typography>}
            {questions?.map((question) => question.multiple ? <QuestionMulti questionaire={questionaire} key={question.id} updateData={updateData} value={getDataFromPointer(question?.pointer) ?? []} getDataFromPointer={getDataFromPointer} questiongroup={question} triggerAction={triggerAction} contextArea={contextArea} variant={variant}/> : <Question key={question.id} question={question}/>)}
        </Stack>
}

export default Questionaire
